// Hooks / Node modules / Styles
import { Link } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons
import { eleswaretechnology_hz_textonly } from "../../../assets";

function CustomBrand() {
  return (
    <Link to="/">
      <img src={eleswaretechnology_hz_textonly} className="h-[50px]" />
    </Link>
  );
}

export default CustomBrand;
